import { render, staticRenderFns } from "./newspapersDigitalEdition.vue?vue&type=template&id=31ba99cc&scoped=true&"
import script from "./newspapersDigitalEdition.vue?vue&type=script&lang=js&"
export * from "./newspapersDigitalEdition.vue?vue&type=script&lang=js&"
import style0 from "./newspapersDigitalEdition.vue?vue&type=style&index=0&id=31ba99cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba99cc",
  null
  
)

export default component.exports